/* Stickidy — sepette minimum adet koruması.
   Custom Sticker satırları (ürün tipi "Kişisel Sticker") sepetten 5'in altına indirilemesin.
   Tema işaretlemesine bağımlı değil: /cart/change.js ve /cart/update.js isteklerini yakalayıp
   adedi yükseltir, her sepet değişiminden sonra da doğrular. Ödemeye geçişte son kontrol yapar.
   Baskı dosyası olmayan satırlar (ürün sayfasından ya da doğrudan /cart/add ile eklenen, üretilemez) sepetten çıkarılır. */
(function () {
  'use strict';
  var root = document.querySelector('[data-stk-cart-min]');
  if (!root) return;
  var MIN = parseInt(root.getAttribute('data-min'), 10) || 5;
  var TYPES = (root.getAttribute('data-types') || 'Kişisel Sticker').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var MSG = root.getAttribute('data-msg') || 'Kişiye özel sticker en az {n} adet sipariş edilir.';
  var MSG_FILE = root.getAttribute('data-msg-file') || 'Kişiye özel sticker yalnız Custom Sticker aracından, tasarım dosyasıyla eklenebilir.';
  var FILE_PROP = root.getAttribute('data-file-prop') || 'Baskı Dosyası';
  var state = { keys: {}, lines: [], ids: {} };   // key→true, sıra→key, variantId→true
  var busy = false, lastFix = 0;

  function guardedType(t) { return TYPES.indexOf(String(t || '').toLowerCase()) >= 0; }
  // Polaroid Sticker satırı (8 Eki 2026): aynı ürün tipi ama adet kuralı yok (tek kare sipariş edilebilir); baskı dosyası gizli "_Baskı Dosyası" özelliğinde
  function isPol(it) { var pr = (it && it.properties) || {}; return it.handle === 'polaroid-sticker' || !!pr['_POL önizleme']; }
  function hasFile(it) { var pr = (it && it.properties) || {}; return !!(pr[FILE_PROP] || pr['_' + FILE_PROP]); }
  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      state = { keys: {}, lines: [], ids: {} };
      (cart.items || []).forEach(function (it) {
        state.lines.push(it.key);
        if (guardedType(it.product_type) && !isPol(it)) { state.keys[it.key] = true; state.ids[String(it.variant_id || it.id)] = true; }
      });
      return cart;
    }).catch(function () { return null; });
  }
  function guardedKey(k) { return !!state.keys[String(k)]; }
  function keyOfLine(n) { n = parseInt(n, 10); return (n >= 1 && state.lines[n - 1]) ? state.lines[n - 1] : null; }
  function guardedRef(ref) {
    // ref: satır anahtarı, satır numarası ya da varyant kimliği
    var s = String(ref);
    if (state.keys[s]) return true;
    if (state.ids[s]) return true;
    if (/^\d+$/.test(s) && s.length < 6) { var k = keyOfLine(s); return k ? guardedKey(k) : false; }
    return false;
  }
  // Tema, istenen ve dönen adet farklı olunca satırda "yalnızca N adet ekleyebilirsiniz" yazıyor; burada adet bilerek yükseltildi → o metni temizle
  function clearLineErrors() {
    [60, 400, 1200].forEach(function (ms) {
      setTimeout(function () {
        state.lines.forEach(function (k, i) {
          if (!guardedKey(k)) return;
          ['Line-item-error-' + (i + 1), 'CartDrawer-LineItemError-' + (i + 1)].forEach(function (id) {
            var e = document.getElementById(id), t = e && e.querySelector('.cart-item__error-text'); if (t) t.textContent = '';
          });
        });
      }, ms);
    });
  }
  function notice(text) {
    clearLineErrors();
    var now = Date.now(); if (now - lastFix < 1500) return; lastFix = now;
    var el = document.querySelector('[data-stk-cart-min-toast]');
    if (!el) {
      el = document.createElement('div'); el.setAttribute('data-stk-cart-min-toast', '');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;background:#111;color:#fff;font:600 14px/1.35 Jost,system-ui,sans-serif;padding:13px 20px;border-radius:999px;box-shadow:0 14px 34px rgba(0,0,0,.28);max-width:90vw;text-align:center';
      document.body.appendChild(el);
    }
    el.textContent = text || MSG.replace('{n}', MIN);
    el.style.opacity = '1';
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.style.opacity = '0'; el.style.transition = 'opacity .4s'; }, el.textContent.length > 60 ? 6500 : 3200);
  }
  function refreshUI() {
    // /cart sayfasında ana satırlar ve toplam da değişmeli → sayfayı yenile (yalnız çekmeceyi çizmek adedi/tutarı eski bırakıyordu)
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname)) {
      try { var tEl = document.querySelector('[data-stk-cart-min-toast]'); if (tEl && tEl.style.opacity !== '0') sessionStorage.setItem('stkCartMinMsg', tEl.textContent); } catch (e) { /* yoksay */ }
      setTimeout(function () { location.reload(); }, 900); return;
    }
    // diğer sayfalarda temanın sepet çekmecesini tazele
    var drawer = document.querySelector('cart-drawer, cart-notification');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        fetch('/?sections=' + encodeURIComponent(ids), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (sections) {
          drawer.getSectionsToRender().forEach(function (s) {
            var el = document.getElementById(s.id);
            if (el && sections[s.id]) {
              var doc = new DOMParser().parseFromString(sections[s.id], 'text/html');
              var src = doc.querySelector(s.selector || '#' + s.id);
              if (src) el.innerHTML = src.innerHTML;
            }
          });
        }).catch(function () { });
        return;
      } catch (e) { /* yoksay */ }
    }
    if (/\/cart/.test(location.pathname)) setTimeout(function () { location.reload(); }, 400);
  }
  /* --- sepeti doğrula, eksikleri yükselt --- */
  var pending = false;
  function enforce(silent) {
    if (busy) { pending = true; return Promise.resolve(false); }
    busy = true;
    function done(v) {
      busy = false;
      if (pending) { pending = false; setTimeout(function () { enforce(silent); }, 60); }
      return v;
    }
    return readCart().then(function (cart) {
      if (!cart) return done(false);
      var guarded = (cart.items || []).filter(function (it) { return guardedType(it.product_type); });
      var noFile = guarded.filter(function (it) { return !hasFile(it); });
      var low = guarded.filter(function (it) { return noFile.indexOf(it) < 0 && !isPol(it) && it.quantity < MIN; });
      if (!noFile.length && !low.length) return done(false);
      var updates = {};
      noFile.forEach(function (it) { updates[it.key] = 0; });
      low.forEach(function (it) { updates[it.key] = MIN; });
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.json(); })
        .then(function () { done(true); if (!silent || noFile.length) { lastFix = 0; notice(noFile.length ? MSG_FILE : null); refreshUI(); } return true; })
        .catch(function () { return done(false); });
    });
  }
  /* --- istek gövdesini düzelt --- */
  function fixJson(obj) {
    var changed = false;
    if (obj && typeof obj === 'object') {
      if (obj.updates && typeof obj.updates === 'object') {
        if (Array.isArray(obj.updates)) {
          obj.updates = obj.updates.map(function (q, i) {
            var k = state.lines[i];
            if (k && guardedKey(k) && +q > 0 && +q < MIN) { changed = true; return MIN; }
            return q;
          });
        } else {
          Object.keys(obj.updates).forEach(function (k) {
            var q = +obj.updates[k];
            if (guardedRef(k) && q > 0 && q < MIN) { obj.updates[k] = MIN; changed = true; }
          });
        }
      }
      if (obj.quantity != null && (obj.id != null || obj.line != null)) {
        var ref = obj.id != null ? obj.id : keyOfLine(obj.line);
        var q2 = +obj.quantity;
        if (ref != null && guardedRef(ref) && q2 > 0 && q2 < MIN) { obj.quantity = MIN; changed = true; }
      }
    }
    return changed;
  }
  function fixParams(p) {
    var changed = false;
    var qty = p.get('quantity'), id = p.get('id'), line = p.get('line');
    if (qty != null && (id != null || line != null)) {
      var ref = id != null ? id : keyOfLine(line);
      if (ref != null && guardedRef(ref) && +qty > 0 && +qty < MIN) { p.set('quantity', String(MIN)); changed = true; }
    }
    var ups = [];
    p.forEach(function (v, k) { var m = /^updates\[(.+)\]$/.exec(k); if (m) ups.push([k, m[1], v]); });
    ups.forEach(function (u) { if (guardedRef(u[1]) && +u[2] > 0 && +u[2] < MIN) { p.set(u[0], String(MIN)); changed = true; } });
    return changed;
  }
  var isCartWrite = function (u) { return /\/cart\/(change|update)(\.js)?(\?|$)/.test(String(u)); };

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string' || input instanceof URL) ? String(input) : (input && input.url) || '';
      if (isCartWrite(url) && init && init.body) {
        if (typeof init.body === 'string') {
          var b = init.body.trim();
          if (b.charAt(0) === '{') { var o = JSON.parse(b); if (fixJson(o)) { init = Object.assign({}, init, { body: JSON.stringify(o) }); notice(); } }
          else { var p = new URLSearchParams(b); if (fixParams(p)) { init = Object.assign({}, init, { body: p.toString() }); notice(); } }
        } else if (init.body instanceof URLSearchParams) {
          if (fixParams(init.body)) notice();
        } else if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
          var fd = init.body, changed = false;
          var q = fd.get('quantity'), id = fd.get('id'), ln = fd.get('line');
          if (q != null && (id != null || ln != null)) {
            var ref = id != null ? id : keyOfLine(ln);
            if (ref != null && guardedRef(ref) && +q > 0 && +q < MIN) { fd.set('quantity', String(MIN)); changed = true; }
          }
          var pairs = []; fd.forEach(function (v, k) { var m = /^updates\[(.+)\]$/.exec(k); if (m) pairs.push([k, m[1], v]); });
          pairs.forEach(function (u) { if (guardedRef(u[1]) && +u[2] > 0 && +u[2] < MIN) { fd.set(u[0], String(MIN)); changed = true; } });
          if (changed) notice();
        }
      }
    } catch (e) { /* yoksay */ }
    var pr = _fetch.call(this, input, init);
    try {
      var u2 = (typeof input === 'string' || input instanceof URL) ? String(input) : (input && input.url) || '';
      if (/\/cart\//.test(u2)) pr.then(function () { setTimeout(function () { enforce(false); }, 250); }).catch(function () { });
    } catch (e) { /* yoksay */ }
    return pr;
  };
  var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__stkUrl = u; return _open.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (isCartWrite(this.__stkUrl) && body) {
        if (typeof body === 'string') {
          var b = body.trim();
          if (b.charAt(0) === '{') { var o = JSON.parse(b); if (fixJson(o)) { arguments[0] = JSON.stringify(o); body = arguments[0]; notice(); } }
          else { var p = new URLSearchParams(b); if (fixParams(p)) { arguments[0] = p.toString(); body = arguments[0]; notice(); } }
        } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
          var changed = false, pairs = [];
          body.forEach(function (v, k) { var m = /^updates\[(.+)\]$/.exec(k); if (m) pairs.push([k, m[1], v]); });
          pairs.forEach(function (u) { if (guardedRef(u[1]) && +u[2] > 0 && +u[2] < MIN) { body.set(u[0], String(MIN)); changed = true; } });
          if (changed) notice();
        }
      }
      if (/\/cart\//.test(String(this.__stkUrl))) this.addEventListener('load', function () { setTimeout(function () { enforce(false); }, 250); });
    } catch (e) { /* yoksay */ }
    return _send.apply(this, arguments);
  };
  /* --- ödemeye geçişte son kontrol --- */
  function guardCheckout(e) {
    var t = e.target.closest ? e.target.closest('[name="checkout"], button[name="checkout"], a[href*="/checkout"]') : null;
    if (!t) return;
    if (t.__stkOk) { t.__stkOk = false; return; }
    e.preventDefault(); e.stopPropagation();
    enforce(true).then(function (fixed) {
      if (fixed) { notice(); refreshUI(); return; }
      t.__stkOk = true;
      if (t.form) t.form.__stkOk = true;   // form gönderimi de doğrulandı sayılsın (checkout alanı korunur)
      if (t.tagName === 'A') location.href = t.getAttribute('href');
      else t.click();
    });
  }
  document.addEventListener('click', guardCheckout, true);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !/\/cart/.test(f.getAttribute('action') || '')) return;
    if (f.__stkOk) { f.__stkOk = false; return; }
    var sub = e.submitter || null;   // name="checkout" düğmesi: form.submit() bu alanı düşürür, o yüzden requestSubmit(submitter)
    e.preventDefault();
    enforce(true).then(function (fixed) {
      if (fixed) { notice(); refreshUI(); return; }
      f.__stkOk = true;
      if (sub && typeof f.requestSubmit === 'function') { f.requestSubmit(sub); return; }
      if (sub && sub.name) { var h = document.createElement('input'); h.type = 'hidden'; h.name = sub.name; h.value = sub.value || ''; f.appendChild(h); }
      f.submit();
    });
  }, true);
  /* --- başlangıç --- */
  // /cart yenilenmeden önceki bildirim (ör. dosyasız satır çıkarıldı) yenilemeden sonra da görünsün
  try { var pend = sessionStorage.getItem('stkCartMinMsg'); if (pend) { sessionStorage.removeItem('stkCartMinMsg'); setTimeout(function () { lastFix = 0; notice(pend); }, 300); } } catch (e) { /* yoksay */ }
  readCart().then(function () { enforce(false); });
  document.addEventListener('shopify:section:load', function () { readCart(); });
})();